export const dnldWARates = (builder) => ({
    dnldWARates: builder.mutation({
      query: ({ startDate, endDate, search, loggedin_user_id, user_type_id, }) => {
        return {
          url: '/download_whatsapp_rate_list',
          method: 'GET',
          params: { startDate, endDate, search, loggedin_user_id, user_type_id, },
          headers: {
            'Content-Type': 'text/csv',
          },
          responseHandler: (response)=>response.blob(),
        };
      },
    }),
  });
  